import { createSlice } from '@reduxjs/toolkit';
import { TParamState } from 'shared/mf-infrastructure/types/params';

const initialState = null as TParamState | null;

/* istanbul ignore next */
export const paramsSlice = createSlice({
  initialState,
  name: 'params',
  reducers: {},
});
